import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 100 100" {...props}>
      <title>{props.title || 'Palette'}</title>
      <g>
        <path d="M84.7 81.6c-.2-4-6.2-15.9-6-20.5.2-5.2 3.3-11.7 9.9.9 4 7.6 10 2.9 10.8-.8 2.2-11.1-1.1-24.5-11.6-37.5-18.2-22.6-50.2-28.8-71.4-13.9-21.2 15-21.7 48.6-2.3 68.1 17.6 17.7 41.8 25.4 62 16.9 2.1-.8 9-3.5 8.6-13.2zm-56.8-65.5c3.8-2.7 9.1-1.8 11.8 2.1 2.7 3.8 1.8 9.1-2.1 11.8-3.8 2.7-9.1 1.8-11.8-2.1s-1.8-9.1 2.1-11.8zm-16.6 34.5c-2.7-3.8-1.8-9.1 2.1-11.8 3.8-2.7 9.1-1.8 11.8 2 2.7 3.8 1.8 9.1-2.1 11.8-3.8 2.7-9.1 1.8-11.8-2zm41.2-22.1c-2.7-3.8-1.8-9.1 2.1-11.8 3.8-2.7 9.1-1.8 11.8 2.1 2.7 3.8 1.8 9.1-2.1 11.8-3.8 2.6-9.1 1.7-11.8-2.1zm-28.7 43.7c-2.7-3.8-1.8-9.1 2-11.8 3.8-2.7 9.1-1.8 11.8 2.1 2.7 3.8 1.8 9.1-2.1 11.8-3.7 2.7-9 1.7-11.7-2.1z" />
      </g>
    </Icon>
  )
}
